import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Link } from 'react-router-dom';
import './_header.scss';
import PatientHeaderNav from './components/header-nav';
import headerLogo from './images/what-the-cah-logo.svg';
import { LayoutContext } from "@/components/layout-context-container";
import CustomImage from "@/components/image";

function PatientHeader() {
  const containerRef = useRef(null);
  const {showMobileMenu, setShowMobileMenu} = useContext(LayoutContext);
  const [subnavGroupSize, setSubnavGroupSize] = useState(null);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth >= 1024) {
        // auto close mobile menu if opened from desktop and screen becomes larger than tablet size
        setShowMobileMenu(false);
      }
    }

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [setShowMobileMenu]);

  useEffect(() => {
    // disable page scroll if mobile menu is open
    if (showMobileMenu) {
      // open
      document.body.style.position = "sticky";
      document.body.style.height = "100%";
      document.body.style.overflow = "hidden";
    } else {
      // close
      document.body.style.position = "";
      document.body.style.height = "";
      document.body.style.overflow = "";
    }

  }, [showMobileMenu]);

  const containerClass = useMemo(() => {
    var className = 'header';
    
    if (showMobileMenu) {
      className = `${className} header--mobile-menu-showing`;
    }
    
    return className;
  }, [showMobileMenu]);

  const mobileNavWrapperClass = useMemo(() => {
    var className = 'header__mobile-nav-wrapper';
    
    if (showMobileMenu) {
      className = `${className} header__mobile-nav-wrapper--mobile-menu-showing`;
    }
    
    return className;
  }, [showMobileMenu]);

  useEffect(() => {
    if (subnavGroupSize !== null) {
      const size = 51 + (subnavGroupSize * 43);
      containerRef.current?.style.setProperty('--subnav-height', `${size}px`);
    }
  }, [subnavGroupSize]);

  return (
    <>
      <header className={containerClass} ref={containerRef}>
        <div className="container container--desktop-medium !max-w-[1325px]">
          <div className="header__nav-wrapper">
            <div className='header__logo'>
              <Link
                to="/"
                data-gtm-event-name="Header"
                data-gtm-event-category="Navigation"
                data-gtm-event-action="Click"
                data-gtm-event-label="WhatTheCAH Logo"
                onClick={() => setShowMobileMenu(false)}
              >
                <CustomImage
                  loading="eager"        
                  // @ts-ignore
                  fetchpriority="high"
                  src={headerLogo} 
                  width={123}
                  height={53}
                  alt="What the CAH?! logo"
                />
              </Link>
            </div>
            <PatientHeaderNav setSubnavGroupSize={setSubnavGroupSize} />
          </div>
        </div>
        <div className={`header__subnav-drawer ${subnavGroupSize ? 'header__subnav-drawer--open' : ''}`.trim()}>
          <div />
        </div>
      </header>
      <div className="header__mobile-nav-wrapper-constrain">
        <div className={mobileNavWrapperClass}>
          <PatientHeaderNav customClass="container container--desktop-medium" mobile />
          <br />
          <br />
          <br />
        </div>
      </div>
    </>
  )
}

export default PatientHeader;